import { useEffect } from "react";

function isTyping(target: EventTarget | null): boolean {
	if (!(target instanceof HTMLElement)) return false;
	const tag = target.tagName;
	return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || target.isContentEditable;
}

/**
 * Single-key shortcut (e.g. "q") that never fires while typing in a field or
 * with a modifier held, so it cannot clash with browser shortcuts.
 */
export function useHotkey(key: string, handler: () => void): void {
	useEffect(() => {
		const onKeyDown = (e: KeyboardEvent) => {
			if (e.ctrlKey || e.metaKey || e.altKey || e.repeat) return;
			if (e.key.toLowerCase() !== key.toLowerCase() || isTyping(e.target)) return;
			e.preventDefault();
			handler();
		};
		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
	}, [key, handler]);
}
